// extracted by mini-css-extract-plugin
export default {"wrapper":"forumContentPopup_wrapper__xn1MG"};